import { UPDATE_DISABLED_LAYERS } from '../../constants/appTypes';

const initialState: Array<string> = ['protected-areas'];

interface visibleLayersAction {
  disabledLayers: Array<string>;
  type: string;
}

export function disabledLayers(state = initialState, action: visibleLayersAction) {
  switch (action.type) {
    case UPDATE_DISABLED_LAYERS:
      state = action.disabledLayers;
      return state;
    default:
      return state;
  }
}

export default disabledLayers;
